module.exports = __webpack_public_path__ + "media/images/photo13-a8293d0d655c2a030fa24f119c40082b.png";